var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var isDevelopment = process.env.NODE_ENV !== 'production';
var cache = {};
var wrapCache = {};
var addToCache = function (key) {
    cache[key] = true;
};
export var wrap = function (key) {
    var keyValue = wrapCache[key];
    wrapCache[key] = wrapCache[key] ? keyValue + 1 : 1;
};
export var unwrap = function (key) {
    if (wrapCache[key]) {
        wrapCache[key]--;
    }
};
export function deprecationLog(componentName) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (isDevelopment && !(cache[componentName] || wrapCache[componentName])) {
        console.warn.apply(console, __spreadArray(['wix-ui-tpa: [WARNING]'], args, false));
        addToCache(componentName);
    }
}
//# sourceMappingURL=deprecationLog.js.map